export type CompetitionDetailsTabLayout = {
  showSessionsTab: boolean;
  showScoreSubmissions: boolean;
  showPhotosTab: boolean;
  showActivityTab: boolean;
};

export type CompetitionDetailsTabIndices = {
  feed: number;
  ranking: number;
  photos: number | null;
  sessions: number | null;
  yourScores: number | null;
  activity: number | null;
};

export const buildCompetitionDetailsTabIndices = (
  layout: CompetitionDetailsTabLayout
): CompetitionDetailsTabIndices => {
  let nextIndex = 0;
  const feed = nextIndex++;
  const ranking = nextIndex++;
  const sessions = layout.showSessionsTab ? nextIndex++ : null;
  const photos = layout.showPhotosTab ? nextIndex++ : null;
  const yourScores = layout.showScoreSubmissions ? nextIndex++ : null;
  const activity = layout.showActivityTab ? nextIndex++ : null;

  return {
    feed,
    ranking,
    photos,
    sessions,
    yourScores,
    activity,
  };
};
